import React, { useCallback, useMemo, useState } from 'react'
import _ from 'lodash'
import {
  Box,
  VStack,
  FormControl as ChakraFormControl,
  FormErrorMessage as ChakraFormErrorMessage,
} from '@chakra-ui/react'
import type { SingleValue } from 'react-select'
import { useTranslation } from 'react-i18next'

import { IKReactSelect } from '../../../../ui-kit'
import type { InputFormProps as Props } from '../../../interfaces'
import { privacyOptions } from '../../../../utils/mediaLibrary'

const PrivacyInputForm = (props: Props): React.ReactElement => {
  const {
    searchQueryJson,
    validationObject,
    groupId,
    filterId,
    setSearchQueryJson,
  } = props
  const { t } = useTranslation()

  const [dirty, setDirty] = useState<boolean>(false)

  const expression = useMemo(
    () => searchQueryJson.filterGroups[groupId]?.expressions[filterId],
    [searchQueryJson, groupId, filterId],
  )

  const error: string | null = useMemo(
    () => validationObject.errors[groupId][filterId],
    [validationObject, groupId, filterId],
  )

  const handleValueChange = useCallback(
    (newValue: string) => {
      const newSearchQueryJson = _.cloneDeep(searchQueryJson)
      newSearchQueryJson.filterGroups[groupId].expressions[filterId].value =
        newValue
      setSearchQueryJson(newSearchQueryJson)
    },
    [searchQueryJson, groupId, filterId],
  )

  return (
    <ChakraFormControl width="full" isInvalid={error !== null && dirty}>
      <VStack width="full" spacing="0.5em">
        <Box width="full">
          <IKReactSelect
            menuPlacement='auto'
            placeholder={t('select_an_option', 'Select an option')}
            variant="compact"
            isSearchable={false}
            options={Object.keys(privacyOptions).map(key => ({
              label: key,
              value: key,
            }))}
            value={
              expression.value !== ''
                ? {
                    label: expression.value as string,
                    value: expression.value as string,
                  }
                : null
            }
            onChange={(
              newVal: SingleValue<{
                label: string
                value: string
              }>,
            ) => {
              newVal?.value && handleValueChange(newVal.value)
              setDirty(true)
            }}
          />
        </Box>
        <ChakraFormErrorMessage width="full">{error}</ChakraFormErrorMessage>
      </VStack>
    </ChakraFormControl>
  )
}

export default PrivacyInputForm
